// extracted by mini-css-extract-plugin
export default {"gorodWrap":"gorod_gorodWrap__+mb7z","mainPhoto":"gorod_mainPhoto__aKqJ9","baseText":"gorod_baseText__IWMbZ","logoWrap":"gorod_logoWrap__DASlO"};